const CheckIcon = ({ fill }: { fill: string }) => {
  return (
    <svg
      width="0.8125rem"
      height="0.75rem"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5965 0.965843L4.4365 7.87584L2.5365 5.84584C2.1865 5.51584 1.6365 5.49584 1.2365 5.77584C0.846504 6.06584 0.736503 6.57584 0.976503 6.98584L3.2265 10.6458C3.4465 10.9858 3.8265 11.1958 4.2565 11.1958C4.6665 11.1958 5.0565 10.9858 5.2765 10.6458C5.6365 10.1758 12.5065 1.98584 12.5065 1.98584C13.4065 1.06584 12.3165 0.255843 11.5965 0.955843V0.965843Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckIcon;
